/** Tracks mutually exclusive views within the editor sidebar. */
export enum SidebarView {
  NOTEBOOK = "NOTEBOOK",
  SETTINGS = "SETTINGS",
  ADD_ONS = "ADD_ONS",
  ADD_DATA = "ADD_DATA",
}
